import { SHARE_URLS_URL } from '../constants/urls';

import { get } from './index';

export const getShareURLsForHandle = handle => {
  return get(`/profile/${handle}${SHARE_URLS_URL}`);
};
